import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import duration from 'dayjs/plugin/duration'

import 'dayjs/locale/de'
import 'dayjs/locale/en'
import 'dayjs/locale/hu'
import 'dayjs/locale/tr'
import 'dayjs/locale/uk'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(localizedFormat)
dayjs.extend(duration)

export function guessTimezone() {
  return dayjs.tz.guess()
}

export function availableTimezones() {
  return Intl.supportedValuesOf('timeZone')
}

export function availableTimezonesOptions() {
  return availableTimezones().map((tz) => {
    return {
      value: tz,
      label: tz,
    }
  }).sort((a, b) => a.label.localeCompare(b.label))
}

export function getCurrentYear(timezone?: string) {
  return dayjs().tz(timezone ?? guessTimezone()).year()
}

export function isoMonthToDate(isoMonth: string) {
  return dayjs(isoMonth, 'YYYY-MM').toDate()
}

export function dateToIsoMonth(date: Date) {
  return dayjs(date).format('YYYY-MM')
}

export function isoDateToDate(isoMonth: string) {
  return dayjs(isoMonth, 'YYYY-MM-DD').toDate()
}

export function dateToIsoDate(date: Date) {
  return dayjs(date).format('YYYY-MM-DD')
}

export function formatMonth(isoMonth: string, locale: LocaleType) {
  let format = 'MM/YYYY'
  if (locale === 'de') {
    format = 'MM/YYYY'
  }
  if (locale === 'en') {
    format = 'MM/YYYY'
  }
  if (locale === 'hu') {
    format = 'YYYY.MM'
  }
  if (locale === 'tr') {
    format = 'MM.YYYY'
  }
  if (locale === 'uk') {
    format = 'MM.YYYY'
  }

  return dayjs(isoMonth, 'YYYY-MM').format(format)
}

export function formatInstant(
  date: Date,
  tz: string,
  locale: LocaleType,
  format: string = 'LLL',
) {
  return dayjs(date)
    .tz(tz)
    .locale(locale)
    .format(format)
}

export function formatSeconds(seconds: number) {
  const time = dayjs.duration(seconds, 'seconds')
  return time.format('mm:ss')
}

export function getAge(dateOfBirth: string, tz: string) {
  const now = dayjs().tz(tz)
  const birthDate = dayjs(dateOfBirth).tz(tz)
  return now.diff(birthDate, 'years')
}
